// Releases media, stylesheets (data-interaction-media) and scripts (data-interaction-script) held back until the first interaction.
const RELEASE_EVENTS = ['scroll', 'mouseover', 'touchstart', 'pointerdown', 'keydown'];

const releaseMedia = () => {
  document.documentElement.dataset.mediaReleased = 'true';

  for (const media of document.querySelectorAll('[data-interaction-media]')) {
    const { src, srcset, href } = media.dataset;
    media.removeAttribute('data-interaction-media');
    if (srcset) media.srcset = srcset;
    if (src) media.src = src;
    if (href) media.href = href;
  }

  // A parsed <script> never runs a src set later, so each held one is fetched as a new element, in document order
  for (const held of document.querySelectorAll('script[data-interaction-script]')) {
    const script = document.createElement('script');
    script.src = held.dataset.src;
    script.async = false;
    held.replaceWith(script);
  }

  for (const eventName of RELEASE_EVENTS) {
    window.removeEventListener(eventName, releaseMedia);
  }
  document.removeEventListener('theme:cart:opened', releaseMedia);

  document.dispatchEvent(new CustomEvent('theme:media:released'));
};

// Already scrolled (restored position, or scrolled before this deferred script ran)
if (window.scrollY > 0) {
  releaseMedia();
} else {
  for (const eventName of RELEASE_EVENTS) {
    window.addEventListener(eventName, releaseMedia, { once: true, passive: true });
  }
  // The cart drawer can open with no interaction (?open-cart redirect); its held stylesheet must load then too
  document.addEventListener('theme:cart:opened', releaseMedia, { once: true });
}
